import styled from '@emotion/styled';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Arranger from '~c/components/base/arranger';
import Button from '~c/components/base/button';
import { DesignToken } from '~c/components/base/core';
import { BrandLogo as BrandLogoDark } from '~c/components/base/icon/asenion-logo-dark';
import Spacer, { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
  /** Override the default message */
  message?: string;
}

const AccessDeniedPageImpl: React.FC<Props> = ({ className, message }) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <Arranger direction="column" alignItems="center" justify="center">
        <div className="logo-container">
          <BrandLogoDark />
        </div>

        <Spacer mb={spc.xl} />

        <div className="lock-icon">
          <LockOutlinedIcon />
        </div>

        <Spacer mb={spc.xs} />

        <Text sz="subheading-first" className="error-title">
          Access Denied
        </Text>

        <Spacer mb={spc.s} />

        <Text sz="body16" className="error-description" align="center">
          {message ??
            "You don't have permission to access this page. Contact your organization admin if you believe this is a mistake."}
        </Text>

        <Spacer mb={spc.xl} />

        <Arranger direction="row" alignItems="center" className="error-actions">
          <Button onClick={() => navigate(-1)} outlined>
            Go Back
          </Button>
          <Spacer mr={spc.s} />
          <Button onClick={() => navigate('/')} color="primary">
            Go Home
          </Button>
        </Arranger>
      </Arranger>
    </div>
  );
};

const AccessDeniedPage = styled(AccessDeniedPageImpl)`
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spc.xl * 4}px;
  background-color: ${DesignToken.surface2};

  .logo-container {
    margin-bottom: ${spc.l * 4}px;
    margin-right: ${spc.l * 2}px;
    svg {
      width: 250px;
      height: 100px;
    }
  }

  .lock-icon {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: ${DesignToken.status.danger}20;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${spc.m * 4}px;
    svg {
      width: 60px;
      height: 60px;
      color: ${DesignToken.status.danger};
    }
  }

  .error-title {
    color: ${DesignToken.textPrimary};
    font-weight: 600;
    margin: 0;
  }

  .error-description {
    color: ${DesignToken.textMuted};
    max-width: 440px;
    line-height: 1.6;
    margin: 0;
  }

  .error-actions {
    gap: ${spc.s * 4}px;
  }
`;

export default AccessDeniedPage;
